var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "564AD728-9D59-45A4-AFC7-6028435C3B38") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share-Modal",
    transform: "translate(-1134.000000, -451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(682.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(452.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2A71D4",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.593668,30.2050682 C59.8455937,29.987747 60.2017812,29.9381059 60.5045566,30.0803996 C60.8064512,30.2210763 61,30.5267651 61,30.8627722 L61,30.8627722 L61,52.5504295 C61,54.4529606 59.4677051,56 57.5833867,56 L57.5833867,56 L23.4166934,56 C21.5322949,56 20,54.4529606 20,52.5504295 L20,52.5504295 L20,30.8627722 C20,30.5267651 20.1935488,30.2218848 20.4954434,30.0803187 C20.7957363,29.9397229 21.1527246,29.9876661 21.406332,30.2049874 C26.5004219,34.5641054 35.4441875,42.2405255 38.1151133,44.6701899 C39.5248086,45.9536627 41.4767129,45.9536627 42.883125,44.6718878 C45.3889297,42.3921976 53.3533398,35.5460935 59.593668,30.2050682 Z M58.0573971,25 C59.1342184,25 60.1389444,25.4850078 60.8128219,26.3308971 C61.1043307,26.6969607 61.0494361,27.223263 60.6893709,27.5226885 C54.906024,32.3412698 44.7581929,40.8194336 41.7730671,43.4652768 C41.3735799,43.8203285 40.944876,44 40.4999588,44 C40.0541364,44 39.6246918,43.8186281 39.2242992,43.4618761 C36.2417248,40.8186239 26.0938937,32.3412698 20.3106291,27.5226885 C19.9505639,27.223263 19.8956693,26.6969607 20.1871781,26.3309781 C20.8609733,25.4850078 21.8657816,25 22.9425206,25 L22.9425206,25 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1d23d6112f774c470f62b48be602643f.svg";
export { ForwardRef as ReactComponent };